import styled from "styled-components";
import Block from "../Block";

export const StyledBody = styled(Block)``;
export const StyledHeaderImage = styled(Block)``;
